import { faEdit, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useForm } from "react-hook-form";
import { ListarClassificacaoCobrancaController } from "../../../../../../Controllers/Cobranca/ClassificacaoCobranca/ClassificacaoCobrancaController";
import {
    AtualizarResultadoContatoController,
    InserirResultadoContatoController,
} from "../../../../../../Controllers/Cobranca/ResultadoContato/ResultadoContatoController";
import { ClassificacaoCobrancaInterface } from "../../../../../../Interfaces/Cobranca/ClassificacaoCobranca/ClassificacaoCobrancaInterface";
import { IResultadoContato } from "../../../../../../Interfaces/Cobranca/ResultadoContato/ResultadoContatoInterface";
import LazySelect from "../../../../../CardsPages/Forms/LazySelect";
import { Switch } from "../../../../../CardsPages/Forms/Switch";

interface ICadastrarResultadoContatoProps {
    then(): void;
    edit?: IResultadoContato;
    ListarClassificacaoCobranca: () => Promise<
        ClassificacaoCobrancaInterface[]
    >;
}

interface ResultadoContatoFormData {
    classificacao: string;
    resultado: string;
    tempo: number;
    ID_CASO_COBRANCA_CLASSIFICACAO_COBRANCA?: number;
    FL_ATIVO: boolean;
}

const editarObj = {
    icon: faEdit,
    buttonText: "Editar",
    controller: AtualizarResultadoContatoController,
    color: "primary",
    title: "",
};
const cadastrarObj = {
    icon: faPlus,
    buttonText: "Cadastrar",
    controller: InserirResultadoContatoController,
    color: "success",
    title: "Cadastre Resultado do Contato",
};

export default function CadastrarEditarResultadoContato(
    props: ICadastrarResultadoContatoProps
) {
    const { register, handleSubmit, formState, reset, setValue } = useForm();

    const editarOuCadastrarObj = props.edit ? editarObj : cadastrarObj;

    const handleResultadoContatoFormSubmit = (
        formData: ResultadoContatoFormData
    ) => {
        editarOuCadastrarObj
            .controller({
                DS_CLASSIFICACAO: formData.classificacao,
                DS_RESULTADO_CONTATO: formData.resultado,
                NR_TEMPO_RETORNO_FILA: formData.tempo,
                FL_ATIVO: formData.FL_ATIVO,
                ID_CASO_COBRANCA_RESULTADO_CONTATO:
                    props.edit?.ID_CASO_COBRANCA_RESULTADO_CONTATO ?? 0,
                ID_CASO_COBRANCA_CLASSIFICACAO_COBRANCA:
                    formData.ID_CASO_COBRANCA_CLASSIFICACAO_COBRANCA,
            })
            .then(() => {
                props.then();
                reset();
            });
    };

    return (
        <div className="col-12">
            <h5 className="text-center">{editarOuCadastrarObj.title}</h5>
            <form
                onSubmit={handleSubmit(handleResultadoContatoFormSubmit)}
                className="w-100 align-itens-center"
            >
                <div className="row mb-3">
                    <div className="col-12 col-lg-6">
                        <label htmlFor="resultado">Resultado do Contato</label>
                        <input
                            type="text"
                            name="resultado"
                            className={`form-control placeholder-dark-50 ${
                                formState.errors.resultado && "is-invalid"
                            }`}
                            defaultValue={props.edit?.DS_RESULTADO_CONTATO}
                            ref={register({
                                required: "Insira o resultado do contato",
                            })}
                        />
                    </div>
                    <div className="col-12 col-lg-6">
                        <label htmlFor="classificacao">Classificação</label>
                        <select
                            name="classificacao"
                            className={`form-control placeholder-dark-50 ${
                                formState.errors.classificacao && "is-invalid"
                            }`}
                            defaultValue={props.edit?.DS_CLASSIFICACAO}
                            ref={register({
                                required: "Insira a classificacao do contato",
                            })}
                        >
                            <option>Não Efetivo</option>
                            <option>Contato Efetivo</option>
                            <option>Tentativa de Contato</option>
                        </select>
                    </div>
                    <div className="col-12 col-lg-6">
                        <label htmlFor="number">
                            Tempo de espera (em horas)
                        </label>
                        <input
                            type="number"
                            name="tempo"
                            className={`form-control placeholder-dark-50 ${
                                formState.errors.tempo && "is-invalid"
                            }`}
                            defaultValue={props.edit?.NR_TEMPO_RETORNO_FILA}
                            ref={register({
                                required: "Insira o tempo de espera",
                                min: {
                                    value: 0,
                                    message:
                                        "O tempo de espera mínimo é de 0 horas",
                                },
                            })}
                        />
                    </div>
                    <div className="col-12 col-lg-6">
                        <label htmlFor="number">
                            Atualizar Classificação de Contrato:
                        </label>
                        <LazySelect
                            name="ID_CASO_COBRANCA_CLASSIFICACAO_COBRANCA"
                            setValue={setValue}
                            controller={ListarClassificacaoCobrancaController}
                            getKeyValue={(cc) =>
                                cc.ID_CASO_COBRANCA_CLASSIFICACAO_COBRANCA
                            }
                            getDS={(cc) =>
                                cc.DS_CASO_COBRANCA_CLASSIFICACAO_COBRANCA
                            }
                            defaultValue={
                                props.edit
                                    ?.ID_CASO_COBRANCA_CLASSIFICACAO_COBRANCA
                            }
                            className={`form-control placeholder-dark-50 ${
                                formState.errors
                                    .ID_CASO_COBRANCA_CLASSIFICACAO_COBRANCA &&
                                "is-invalid"
                            }`}
                            ref={register()}
                        >
                            <option></option>
                        </LazySelect>
                    </div>

                    <div className="col-12 col-lg-6">
                        <label htmlFor="FL_ATIVO">Resultado do Contato</label>
                        <Switch
                            type="checkbox"
                            color="primary"
                            name="FL_ATIVO"
                            className={`form-control placeholder-dark-50 ${
                                formState.errors.resultado && "is-invalid"
                            }`}
                            defaultChecked={props.edit?.FL_ATIVO}
                            ref={register()}
                        />
                    </div>
                </div>

                <button
                    className={`btn btn-outline-${editarOuCadastrarObj.color} font-weight-bold d-flex col-12 justify-content-center`}
                >
                    <FontAwesomeIcon
                        icon={editarOuCadastrarObj.icon}
                        size="lg"
                        className="mr-1"
                    />{" "}
                    {editarOuCadastrarObj.buttonText}
                </button>
            </form>
        </div>
    );
}
